import React from 'react'
import PropTypes from 'prop-types'
import { IconSLI60Wrapper } from './IconSLI60Wrapper'

export const Icon60Arrow2Down = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLI60Wrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 27.85 48'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M27.561,33.681 L14.654,47.680 C14.650,47.684 14.643,47.686 14.639,47.690 C14.567,47.765 14.480,47.820 14.388,47.870 C14.363,47.883 14.344,47.906 14.318,47.917 C14.198,47.969 14.066,47.999 13.926,47.999 C13.788,47.999 13.659,47.970 13.543,47.919 C13.414,47.864 13.296,47.785 13.199,47.680 L0.292,33.681 C-0.081,33.277 -0.058,32.643 0.344,32.268 C0.746,31.892 1.374,31.915 1.747,32.320 L12.970,44.493 L12.970,1.000 C12.970,0.447 13.378,-0.000 13.926,-0.000 C14.474,-0.000 14.919,0.447 14.919,1.000 L14.919,44.453 L26.105,32.320 C26.479,31.915 27.106,31.892 27.509,32.268 C27.910,32.643 27.933,33.277 27.561,33.681 Z'
        />
      </svg>
    </IconSLI60Wrapper>
  )
}

Icon60Arrow2Down.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
